



































































import { Component, Vue, Prop } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import LanguageGroup from "@/models/language/languageGroup/languageGroup.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import LanguageService from "@/services/language.service";
import { PermissionValue } from '@/enums/PermissionValue';

@Component
export default class LanguageGroupTable extends GenericBTable<LanguageGroup> {
  isLoading = false;
  languageService = new LanguageService();
  created() {
    this.permissionValue = PermissionValue.IDIOMAS;
    this.tableConfig.controller = "LanguageGroups";
    this.formatColumns();
  }
  formatColumns() {
    let nombre = new BTableColumn("name", "table.name");
    let codigo = new BTableColumn("key", "table.code");
    this.tableConfig.insertColumns(nombre, codigo);
    this.tableConfig.actions.customTemplate = true;
  }

  verOpciones(row: LanguageGroup) {
    this.$router.push(`LanguageGroup/${row.id}/LanguageLabel`);
  }
  generateJSON() {
    this.isLoading = true;
    this.languageService
      .generateJSON()
      .then(msg => {
        localStorage.setItem("locales", JSON.stringify(msg));
        this.$i18n.setLocaleMessage(this.$i18n.locale, msg[this.$i18n.locale]);
        this.operationSuccess();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
